module.exports = __webpack_public_path__ + "static/media/fleet_white.280f10ba.png";